<!-- Screenname: Schedule Master Creation -->
<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="
      model
        ? t('Items.ChecklistMasterTable.EditScheduleMaster')
        : t('Items.ChecklistMasterTable.CreateScheduleMaster')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="insert_data.Name"
              type="text"
              :label="t('Items.ScheduleMaster.Name')"
              clearable
              id="Name"
              name="Name"
              :rules="{ required: true }"
              :required-icon="true"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          
               <div class="field">
          <CustomDropDown v-model="insert_data.CategoryId" :items="ItemCategoryDropdown.ItemCategoryoption"
           @update:modelValue="ItemCategoryOnChange" :label="$t('5003.grouping.category')"  name="Category"
          id="Category" :rules="{ required: true }" :required-icon="true" :tabindex="9" />
        </div>          
        </b-col>
       
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloading"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive, watch } from "vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import axios from "axios";
// import service from "../../../../Service/ScheduleMasterService";
import checkListMaster from "../../../../Service/AssetManagement/CheckListMasterService"
import { useRoute } from "vue-router";
// import ItemMasService from "@/modules/Inventory/Service/ItemMasService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    secondData:{
      type : Number,
      Default:null
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
 

  components: {
    Footer,
    axios,
    useRoute,
    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    CustomDropDown
  },
  setup(props, { emit }) {
    debugger;

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
   
    let UserId = Number(session.UserId);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);
 let ProductId = ref();
    const insert_data = ref({
      Name: "",
      CategoryId:0,
      IsActive:false
    });
       const ItemCategoryDropdown = ref({
      ItemCategoryid: null,
      ItemCategoryoption: [],
      AccountHeadOption: []
    });
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
   
    onMounted(() => {
      debugger;
      console.log(model.value)
      console.log(props.secondData)
      insert_data.value.CategoryId= props.secondData ?? 0;
      console.log("initial secondData:",insert_data.value.CategoryId )
      LoadItemCategory();
      findName(insert_data.value.CategoryId);
      document.addEventListener("keydown", onKeyUp);
    });

   async function findName(data:any) {
    if(data !=0 ){

checkListMaster.getfindonedata(data).then((s:any)=> {
  console.log(s)
        insert_data.value.Name =s.result.Name
        insert_data.value.CategoryId = s.result.CategoryId
        console.log(insert_data.value)
      } )
    }
    
}

     async function LoadItemCategory() {
      debugger;
      try {
        const response = await ItemMasService.ItemCategory();
        console.log(response);
        ItemCategoryDropdown.value.ItemCategoryoption = response["result"]
          .map((item) => {
            item.name= item.Name;
            item.value = item.Id;
          
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }
    const ItemCategoryOnChange = (value: any, option: Selection) => {
    
          debugger;
          let selectedOption: any =
            ItemCategoryDropdown.value.ItemCategoryoption.find(
              (item) => item["Id"] === value
            );
            console.log(selectedOption)
          if (selectedOption) {
            ProductId.value =
              selectedOption["Prefix"] + String(selectedOption["CurrentValue"]);
          }
          
          Grouping.ItemTypeId = value;
          console.log(Grouping.ItemTypeId)
  
        };

  
 let loading = ref(false);
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      } else if (event.altKey && event.key == "n") {
        showDialog.value = true;
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }
  let Grouping = {
      ItemTypeId: ref(),
    
    };
    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));
    function IsClear() {
      showDialog.value = false;
      emit("update:secondData",0);
      emit("update:selectedItem", undefined);
      emit("close");
    }

    function IsCreate() {
      debugger;
      showDialog.value = true;
    }

    async function IsEdit() {
      debugger;
      console.log("hello");
      emit("loadershow");
      try {
        label.value = t("btn.update");
        const EditId = model.value.Id;
        const response = await checkListMaster.updateStatus(EditId);
        const data = response["result"];
        console.log(response["result"]);

        Object.keys(insert_data.value).forEach((key) => {
          if (data[key]) insert_data.value[key] = data[key];
        });

        emit("loaderhide");
        showDialog.value = true;
      } catch (error) {
        emit("loaderhide");
        alert(error);
      }
    }

    const IsSubmit = handleSubmit(async (values) => {
      Saveloading.value = true;
      emit("loadershow");
      try {
        let msg = "";
        insert_data.value.IsActive = true;
        const payload:any = {...insert_data.value}
        payload.CreatedBy = UserId;
        if (Number(props.secondData) == 0 || props.secondData == null) {
  const data_response = await checkListMaster.createdata(payload);
  msg = data_response["ErrorInfo"].ErrorCode;

  if (data_response["result"] == "Already" && msg == null) {
    alreadyexistpop.value = true;
  } else if (msg == null) {
    successpop.value = true;  
  } else {
    alert("something went wrong");
  }
} else {
  const payload:any = { ...insert_data.value };
  payload.Id = Number(props.secondData);
  payload.UpdatedBy = UserId;

  const data_response = await checkListMaster.updateStatus(payload);
  msg = data_response["ErrorInfo"].ErrorCode;

  if (data_response["result"] == "Already" && msg == null) {
    alreadyexistpop.value = true;
  } else if (msg == null) {
    updatepop.value = true;   
  } else {
    alert("something went wrong");
  }
}

      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        console.log(error);
      }
    });

   

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      insert_data.value.Name = "";
    }

    return {
      model,
      showModal: ref(false),
      insert_data,
      IsSubmit,
      IsEdit,
      ItemCategoryDropdown,
      IsClear,
      showDialog,
      IsCreate,
      Grouping, 
      successpop,
      updatepop,
      alreadyexistpop,
      closetrigger,
      alreadyclosetrigger,
      label,
      Saveloading,
      ItemCategoryOnChange,
      t
    };
  },
});
</script>
